class EstimatedShipment extends HTMLElement {
    constructor() {
        super();
        this.render();
    }

    connectedCallback() {
        this.render();
    }

    render() {
        const message = this.getAttribute("data-message") || "Order today to get it between {min} and {max}";
        const minDays = parseInt(this.getAttribute("data-min-days"), 10) || 0;
        const maxDays = parseInt(this.getAttribute("data-max-days"), 10) || 0;
        const preciseDate = this.getAttribute("data-date");
        const workOnlyWeekdays = this.getAttribute("data-work-monday-to-friday") === "true";
        const calcMode = this.getAttribute("data-working-days-calc-mode");

        const today = new Date();
        today.setHours(0,0,0,0);

        let useStaticDates = false;
        let minDate, maxDate;

        function addNoonTime(dateString) {
            if (!dateString) return "";
            if (dateString.includes("T")) return dateString;
            return dateString + "T12:00:00";
        }

        if (!useStaticDates) {
            if (minDays === 0 && maxDays === 0) {
                this.innerHTML = `<p>No delivery information available.</p>`;
                return;
            }
            function addBusinessDays(startDate, days) {
                let count = 0;
                let currentDate = new Date(startDate);
                while (count < days) {
                    currentDate.setDate(currentDate.getDate() + 1);
                    if (workOnlyWeekdays && (currentDate.getDay() === 6 || currentDate.getDay() === 0)) {
                        continue;
                    }
                    count++;
                }
                return currentDate;
            }
            minDate = addBusinessDays(today, minDays);
            maxDate = addBusinessDays(today, maxDays);
        }

        function formatDate(date) {
            if (!date) return "";
            if (typeof date === "string") date = new Date(date);
            const day = date.getDate();
            const month = date.toLocaleDateString("en-EN", { month: "short" });
            return `${month} ${day}`;
        }

        const formattedMinDate = formatDate(minDate);
        const formattedMaxDate = formatDate(maxDate);

        let final_message = `<p>${message.replace('{min}', `<strong>${formattedMinDate}</strong>`).replace('{max}', `<strong>${formattedMaxDate}</strong>`).replace('{date}', `<strong>${preciseDate}</strong>`)}</p>`;
        let checkout_message = `${formattedMinDate} and ${formattedMaxDate}`;

        if ( calcMode == "Minimum days" ){
            final_message = `<p>${message.replace('{min}', `<strong>${formattedMinDate}</strong>`)}`;
            checkout_message = `${formattedMinDate}`;
        }else if ( calcMode == "Maximum days" ){
            final_message = `<p>${message.replace('{max}', `<strong>${formattedMaxDate}</strong>`)}`;
            checkout_message = `${formattedMaxDate}`;
        }

        this.querySelector('.message').innerHTML = final_message;
        if (this.querySelector('input')){
            this.querySelector('input').value = checkout_message;
        }
    }
}

customElements.define("estimated-shipment", EstimatedShipment);